import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSubscriptionApi } from "src/_common/hooks/actions/subscription/appSubscriptionApiHook";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import { useTranslation } from "src/_common/hooks/useTranslation";
import { URLS } from "src/_config";

const PaymentSuccess: React.FC = () => {
    const history = useHistory();
    const location = useLocation();
    const subscriptionApi = useSubscriptionApi();
    const userApi = useUserApi();
    const toast = useToaster();
    const { t } = useTranslation("payment");
    const [isProcessing, setIsProcessing] = useState(true);
    const [paymentResponse, setPaymentResponse] = useState<any>(null);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    useEffect(() => {
       // Parse query parameters from URL
        const searchParams = new URLSearchParams(location.search);
        
        // PayPal parameters
        const token = searchParams.get('token');
        const subscription_id = searchParams.get('subscription_id');
        const ba_token = searchParams.get('ba_token');
        
        // Telr parameters
        const payid = searchParams.get('PAYID');
        const acceptance = searchParams.get('ACCEPTANCE');
        const orderRef = searchParams.get('OrderRef');

        console.log('Payment Success - PayPal Token:', token, 'Subscription ID:', subscription_id);
        console.log('Payment Success - Telr PAYID:', payid, 'ACCEPTANCE:', acceptance, 'OrderRef:', orderRef);

        let paymentParams: any = null;

        // Check if PayPal parameters exist
        if (token && subscription_id && ba_token) {
            paymentParams = {
                token: token,
                subscription_id: subscription_id,
                ba_token: ba_token
            };
        }
        // Check if Telr parameters exist
        else if (payid && acceptance && orderRef) {
            paymentParams = {
                PAYID: payid,
                ACCEPTANCE: acceptance,
                OrderRef: orderRef
            };
        }

        if (paymentParams) {
            // Call payment success API
            subscriptionApi.callPaymentSuccess(
                paymentParams,
                (message: string, response: any) => {
                    console.log('Payment success API response:', response);
                    setIsProcessing(false);

                    // Store the response data
                    setPaymentResponse(response);

                    // Refresh user profile to update subscription data
                    userApi.callGetMe(
                        (msg: string, userData: any) => {
                            console.log('User profile refreshed after payment success');
                        },
                        (err: any) => {
                            console.error('Failed to refresh user profile:', err);
                        }
                    );

                    // Check if payment status is "completed"
                    if (response?.status === "completed" || response?.data?.status === "completed") {
                        // Show success modal instead of toast and auto-redirect
                        setShowSuccessModal(true);
                    } else {
                        // For other statuses, show toast and redirect
                        toast.success(message || "Payment completed successfully!");
                        setTimeout(() => {
                            history.push(URLS.SETTINGS.SUBSCRIPTIONS);
                        }, 2000);
                    }
                },
                (error: any) => {
                    console.error('Payment success API error:', error);
                    setIsProcessing(false);
                    toast.error(error?.message || "Failed to process payment confirmation");

                    // Redirect to subscriptions page after showing error
                    setTimeout(() => {
                        history.push(URLS.SETTINGS.SUBSCRIPTIONS);
                    }, 3000);
                }
            );
        } else {
            console.error('Missing payment parameters (PayPal or Telr)');
            setIsProcessing(false);
            toast.error("Transaction failure. Missing payment information. Please contact support.");

            setTimeout(() => {
                history.push(URLS.SETTINGS.SUBSCRIPTIONS);
            }, 2000);
        }
    }, [location.search]);

    return (
        <div className="dashboard-main member-page-wrapper payment-success-wrapper">
            <div className="payment-success-container">
                <div className="payment-success-card">
                    {isProcessing && !showSuccessModal ? (
                        <>
                            <div className="payment-processing-spinner"></div>
                            <h1 className="payment-processing-title">{t("paymentSuccess.processing.title")}</h1>
                            <p className="payment-processing-message" dangerouslySetInnerHTML={{ __html: t("paymentSuccess.processing.message") }}>
                            </p>
                        </>
                    ) : null}
                    
                    {showSuccessModal && (
                        <>
                            <div className="payment-success-icon">
                                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </div>
                            <h1 className="payment-success-title">{t("paymentSuccess.success.title")}</h1>
                            <p className="payment-success-subtitle">
                                {t("paymentSuccess.success.subtitle")}
                            </p>
                            <p className="payment-success-description" dangerouslySetInnerHTML={{ __html: t("paymentSuccess.success.description") }}>
                            </p>

                            {paymentResponse?.data?.transaction_id && (
                                <div className="payment-transaction-card">
                                    <p className="payment-transaction-label">{t("paymentSuccess.success.transactionLabel")}</p>
                                    <p className="payment-transaction-id">{paymentResponse.data.transaction_id}</p>
                                </div>
                            )}

                            <div className="payment-success-actions">
                                <button
                                    onClick={() => history.push(URLS.SETTINGS.SUBSCRIPTIONS)}
                                    className="btn-preview"
                                >
                                    {t("paymentSuccess.success.viewSubscription")}
                                </button>
                                <button
                                    onClick={() => history.push(URLS.DASHBOARD.MAIN)}
                                    className="btn-cancel"
                                >
                                    {t("paymentSuccess.success.goToDashboard")}
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;
